module.exports = __webpack_public_path__ + "static/media/app-store-badge-ru.2bfb6666.svg";